import { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export function Notes({ data, reference, reload }) {
  const [body, setBody] = useState("");
  const [type, setType] = useState("diary");
  const add = async () => {
    if (!body.trim()) return;
    try { await api.post(`/admin/booking/${reference}/notes`, { body, type }); setBody(""); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not add"); }
  };
  const del = async (id) => { try { await api.delete(`/admin/note/${id}`); reload(); } catch (e) { toast.error(e?.response?.data?.detail || "Cannot delete"); } };
  return (
    <div data-testid="jobfile-notes">
      <div className="border border-[#E5E7EB] bg-white p-3 mb-4">
        <div className="flex gap-2 mb-2">
          {["diary", "note"].map(t => <button key={t} data-testid={`note-type-${t}`} onClick={() => setType(t)} className={`px-3 py-1 text-xs font-bold uppercase border ${type === t ? "bg-[#12263A] text-white border-[#12263A]" : "border-[#E5E7EB]"}`}>{t}</button>)}
        </div>
        <textarea data-testid="note-body" value={body} onChange={e => setBody(e.target.value)} rows={3} placeholder="Add a site diary update or note…" className="border border-[#E5E7EB] px-3 py-2 text-sm w-full mb-2" />
        <button data-testid="note-add" onClick={add} className="de-btn-primary"><Plus size={16} /> Add {type}</button>
      </div>
      <div className="space-y-2">
        {(data.notes || []).map(n => (
          <div key={n.id} data-testid={`note-${n.id}`} className="border border-[#E5E7EB] bg-white p-3">
            <div className="flex items-center justify-between">
              <span className="text-[10px] uppercase tracking-widest text-[#C79A3B] font-bold">{n.type}</span>
              <button data-testid={`note-delete-${n.id}`} onClick={() => del(n.id)} className="text-[#6B7280] hover:text-[#C79A3B]"><Trash2 size={13} /></button>
            </div>
            <p className="text-sm mt-1 whitespace-pre-wrap">{n.body}</p>
            <div className="text-xs text-[#6B7280] mt-1">{n.author_name || n.author} · {new Date(n.created_at).toLocaleString("en-GB")}</div>
          </div>
        ))}
        {(data.notes || []).length === 0 && <div className="text-sm text-[#6B7280]">No notes or diary entries yet.</div>}
      </div>
    </div>
  );
}
